var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalBoxGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.492188,
    y: 0.697266,
    width: 3.60753,
    height: 4.1229,
    rx: 0.837313,
    fill: "#38CB89"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.492188,
    y: 5.85156,
    width: 3.60753,
    height: 4.1229,
    rx: 0.837313,
    fill: "#38CB89"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.492188,
    y: 11.0049,
    width: 3.60753,
    height: 4.1229,
    rx: 0.837313,
    fill: "#38CB89"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.00098,
    y: 0.697266,
    width: 3.60753,
    height: 4.1229,
    rx: 0.837313,
    fill: "#38CB89"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.00098,
    y: 5.85156,
    width: 3.60753,
    height: 4.1229,
    rx: 0.837313,
    fill: "#38CB89"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.00098,
    y: 11.0049,
    width: 3.60753,
    height: 4.1229,
    rx: 0.837313,
    fill: "#38CB89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBoxGroup);
export default __webpack_public_path__ + "static/media/vertical-box-group.aab63e34ee513a78ef8e5ea104ae9d7f.svg";
export { ForwardRef as ReactComponent };